import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const PraeventiveKardiologiePage = () => {
  return (
    <Layout>
      <PageHero
        title="Präventive Kardiologie"
        subtitle="Herzgesundheit erhalten durch gezielte Vorsorge und Beratung."
        backgroundImage="/images/Cardiologie.webp"
        ctaText="Vorsorgetermin buchen"
      />

      <ContentSection
        title="Vorbeugen statt behandeln"
        content="Wir beraten Sie zu Risikofaktoren wie Bluthochdruck, Cholesterin, Bewegung und Ernährung – für ein langfristig gesundes Herz. Mit gezielter Prävention können viele Herzerkrankungen vermieden oder frühzeitig erkannt werden."
        image="/images/Cardiologie.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Individuelle Risikobewertung"
        content="Anhand Ihrer persönlichen Vorgeschichte, Laborwerte und Untersuchungsergebnisse erstellen wir ein individuelles Risikoprofil und beraten Sie zu geeigneten Präventionsmaßnahmen."
        image="/images/Kardiologie 2.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="Präventive Kardiologie Diez"
        content="Kardiologische Vorsorge und Prävention im Medicum Diez – individuell abgestimmt und fachärztlich begleitet für Patientinnen und Patienten im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Vorsorgetermin vereinbaren"
        subtitle="Vereinbaren Sie Ihren Termin zur kardiologischen Prävention online oder telefonisch."
        buttonText="Termin buchen"
      />
    </Layout>
  );
};


